if (!customElements.get('product-request-quotation')) {
  customElements.define(
    'product-request-quotation',
    class ProductRequestQuotation extends HTMLElement {
      onVariantChangeUnsubscriber = undefined;
      button = undefined;
      selectors = {
        button: '[data-request-quotation-button]',
      };

      constructor() {
        super();

        this.button = this.querySelector(this.selectors.button);
        this.$form = document.getElementById(this.formId);
      }

      connectedCallback() {
        this.onVariantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.handleVariantChange.bind(this));
      }
      disconnectedCallback() {
        if (onVariantChangeUnsubscriber) {
          this.onVariantChangeUnsubscriber();
        }
      }

      get formId() {
        return this.dataset.formId;
      }

      handleVariantChange(event) {
        const variantId = event.data.variant.id.toString();
        const sku = event.data.variant.sku;
        const baseUrl = this.button.dataset.baseUrl;

        this.button.setAttribute('href', `${baseUrl}?sku=${sku}`);

        // Toggle button visibility
        const variantSettings = window.rashbelProductSettings.variants[variantId];
        const isEnabled = variantSettings.is_enable_request_quotation;
        const $calculatedFields = document.getElementById(`${this.formId}-calculated-fields`);

        if (isEnabled) {
          if ($calculatedFields) {
            $calculatedFields.style.display = 'none';
          }
          if (this.$form) {
            this.$form.style.display = 'none';
          }
          this.style.display = '';
        } else {
          if ($calculatedFields) {
            $calculatedFields.style.display = '';
          }
          if (this.$form) {
            this.$form.style.display = '';
          }

          this.style.display = 'none';
        }
      }
    },
  );
}
